/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConfirmMembershipDto,
  ConfirmTrialVerificationDto,
  ConfirmTrialVerificationResponse,
  CreateMembershipDto,
  CreateTrialVerificationDto,
  GetPriceRequestDto,
  MembershipControllerCancelSubscriptionAutoRenewal201,
  MembershipControllerGetMembership200,
  MembershipControllerRestoreSubscriptionAutoRenewal201,
  MembershipResponse,
  PriceDisplayResponse,
  ProblemDetail,
  SubscriptionsResponseDto,
  TrialVerificationResponse,
  UserAuthenticatedResponse
} from '.././model';

import { customFetcher } from '../../../client/customFetcher';




export const membershipControllerCreateSubscription = (
    createMembershipDto: CreateMembershipDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MembershipResponse>(
      {url: `/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMembershipDto, signal
    },
      );
    }
  


export const getMembershipControllerCreateSubscriptionMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, TError,{data: CreateMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, TError,{data: CreateMembershipDto}, TContext> => {

const mutationKey = ['membershipControllerCreateSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, {data: CreateMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerCreateSubscription(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCreateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>>
    export type MembershipControllerCreateSubscriptionMutationBody = CreateMembershipDto
    export type MembershipControllerCreateSubscriptionMutationError = ProblemDetail

    export const useMembershipControllerCreateSubscription = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscription>>, TError,{data: CreateMembershipDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCreateSubscription>>,
        TError,
        {data: CreateMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCreateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerConfirmSubscription = (
    confirmMembershipDto: ConfirmMembershipDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/membership/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmMembershipDto, signal
    },
      );
    }
  


export const getMembershipControllerConfirmSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, TError,{data: ConfirmMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, TError,{data: ConfirmMembershipDto}, TContext> => {

const mutationKey = ['membershipControllerConfirmSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, {data: ConfirmMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerConfirmSubscription(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerConfirmSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>>
    export type MembershipControllerConfirmSubscriptionMutationBody = ConfirmMembershipDto
    export type MembershipControllerConfirmSubscriptionMutationError = unknown

    export const useMembershipControllerConfirmSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>, TError,{data: ConfirmMembershipDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerConfirmSubscription>>,
        TError,
        {data: ConfirmMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerConfirmSubscriptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerGetUserPrice = (
    getPriceRequestDto: GetPriceRequestDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<PriceDisplayResponse>(
      {url: `/membership/price`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getPriceRequestDto, signal
    },
      );
    }
  


export const getMembershipControllerGetUserPriceMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, TError,{data: GetPriceRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, TError,{data: GetPriceRequestDto}, TContext> => {

const mutationKey = ['membershipControllerGetUserPrice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, {data: GetPriceRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerGetUserPrice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerGetUserPriceMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>>
    export type MembershipControllerGetUserPriceMutationBody = GetPriceRequestDto
    export type MembershipControllerGetUserPriceMutationError = ProblemDetail

    export const useMembershipControllerGetUserPrice = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerGetUserPrice>>, TError,{data: GetPriceRequestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerGetUserPrice>>,
        TError,
        {data: GetPriceRequestDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerGetUserPriceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerCheckVipAccess = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<void>(
      {url: `/membership/vip-access`, method: 'GET', signal
    },
      );
    }
  



export const getMembershipControllerCheckVipAccessQueryKey = () => {
    return [
    `/membership/vip-access`
    ] as const;
    }

    
export const getMembershipControllerCheckVipAccessQueryOptions = <TData = Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMembershipControllerCheckVipAccessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>> = ({ signal }) => membershipControllerCheckVipAccess(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MembershipControllerCheckVipAccessQueryResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>>
export type MembershipControllerCheckVipAccessQueryError = unknown


export function useMembershipControllerCheckVipAccess<TData = Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerCheckVipAccess<TData = Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerCheckVipAccess<TData = Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMembershipControllerCheckVipAccess<TData = Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerCheckVipAccess>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMembershipControllerCheckVipAccessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const membershipControllerGetMembership = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MembershipControllerGetMembership200>(
      {url: `/membership/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getMembershipControllerGetMembershipQueryKey = (id?: string,) => {
    return [
    `/membership/${id}`
    ] as const;
    }

    
export const getMembershipControllerGetMembershipQueryOptions = <TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMembershipControllerGetMembershipQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof membershipControllerGetMembership>>> = ({ signal }) => membershipControllerGetMembership(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MembershipControllerGetMembershipQueryResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetMembership>>>
export type MembershipControllerGetMembershipQueryError = ProblemDetail


export function useMembershipControllerGetMembership<TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerGetMembership>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerGetMembership>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembership<TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerGetMembership>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerGetMembership>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembership<TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMembershipControllerGetMembership<TData = Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembership>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMembershipControllerGetMembershipQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const membershipControllerCancelSubscriptionAutoRenewal = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MembershipControllerCancelSubscriptionAutoRenewal201>(
      {url: `/membership/${id}/cancel-auto-renewal`, method: 'POST', signal
    },
      );
    }
  


export const getMembershipControllerCancelSubscriptionAutoRenewalMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, TError,{id: string}, TContext> => {

const mutationKey = ['membershipControllerCancelSubscriptionAutoRenewal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  membershipControllerCancelSubscriptionAutoRenewal(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCancelSubscriptionAutoRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>>
    
    export type MembershipControllerCancelSubscriptionAutoRenewalMutationError = ProblemDetail

    export const useMembershipControllerCancelSubscriptionAutoRenewal = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCancelSubscriptionAutoRenewal>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCancelSubscriptionAutoRenewalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerRestoreSubscriptionAutoRenewal = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MembershipControllerRestoreSubscriptionAutoRenewal201>(
      {url: `/membership/${id}/restart-auto-renewal`, method: 'POST', signal
    },
      );
    }
  


export const getMembershipControllerRestoreSubscriptionAutoRenewalMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, TError,{id: string}, TContext> => {

const mutationKey = ['membershipControllerRestoreSubscriptionAutoRenewal'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  membershipControllerRestoreSubscriptionAutoRenewal(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerRestoreSubscriptionAutoRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>>
    
    export type MembershipControllerRestoreSubscriptionAutoRenewalMutationError = ProblemDetail

    export const useMembershipControllerRestoreSubscriptionAutoRenewal = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerRestoreSubscriptionAutoRenewal>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMembershipControllerRestoreSubscriptionAutoRenewalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerCreateSubscriptionV1 = (
    createMembershipDto: CreateMembershipDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<MembershipResponse>(
      {url: `/v1/membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMembershipDto, signal
    },
      );
    }
  


export const getMembershipControllerCreateSubscriptionV1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, TError,{data: CreateMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, TError,{data: CreateMembershipDto}, TContext> => {

const mutationKey = ['membershipControllerCreateSubscriptionV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, {data: CreateMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerCreateSubscriptionV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCreateSubscriptionV1MutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>>
    export type MembershipControllerCreateSubscriptionV1MutationBody = CreateMembershipDto
    export type MembershipControllerCreateSubscriptionV1MutationError = ProblemDetail

    export const useMembershipControllerCreateSubscriptionV1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>, TError,{data: CreateMembershipDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCreateSubscriptionV1>>,
        TError,
        {data: CreateMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCreateSubscriptionV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerConfirmSubscriptionV1 = (
    confirmMembershipDto: ConfirmMembershipDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<UserAuthenticatedResponse>(
      {url: `/v1/membership/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmMembershipDto, signal
    },
      );
    }
  


export const getMembershipControllerConfirmSubscriptionV1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, TError,{data: ConfirmMembershipDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, TError,{data: ConfirmMembershipDto}, TContext> => {

const mutationKey = ['membershipControllerConfirmSubscriptionV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, {data: ConfirmMembershipDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerConfirmSubscriptionV1(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerConfirmSubscriptionV1MutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>>
    export type MembershipControllerConfirmSubscriptionV1MutationBody = ConfirmMembershipDto
    export type MembershipControllerConfirmSubscriptionV1MutationError = ProblemDetail

    export const useMembershipControllerConfirmSubscriptionV1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>, TError,{data: ConfirmMembershipDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerConfirmSubscriptionV1>>,
        TError,
        {data: ConfirmMembershipDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerConfirmSubscriptionV1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const subscriptionControllerGetUserSubscriptions = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<SubscriptionsResponseDto>(
      {url: `/v1/membership/subscription`, method: 'GET', signal
    },
      );
    }
  



export const getSubscriptionControllerGetUserSubscriptionsQueryKey = () => {
    return [
    `/v1/membership/subscription`
    ] as const;
    }

    
export const getSubscriptionControllerGetUserSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscriptionControllerGetUserSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>> = ({ signal }) => subscriptionControllerGetUserSubscriptions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SubscriptionControllerGetUserSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>>
export type SubscriptionControllerGetUserSubscriptionsQueryError = unknown


export function useSubscriptionControllerGetUserSubscriptions<TData = Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSubscriptionControllerGetUserSubscriptions<TData = Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSubscriptionControllerGetUserSubscriptions<TData = Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSubscriptionControllerGetUserSubscriptions<TData = Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionControllerGetUserSubscriptions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSubscriptionControllerGetUserSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const membershipControllerConfirmTrialVerification = (
    confirmTrialVerificationDto: ConfirmTrialVerificationDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<ConfirmTrialVerificationResponse>(
      {url: `/v1/membership/trial/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmTrialVerificationDto, signal
    },
      );
    }
  


export const getMembershipControllerConfirmTrialVerificationMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmTrialVerification>>, TError,{data: ConfirmTrialVerificationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmTrialVerification>>, TError,{data: ConfirmTrialVerificationDto}, TContext> => {

const mutationKey = ['membershipControllerConfirmTrialVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerConfirmTrialVerification>>, {data: ConfirmTrialVerificationDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerConfirmTrialVerification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerConfirmTrialVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerConfirmTrialVerification>>>
    export type MembershipControllerConfirmTrialVerificationMutationBody = ConfirmTrialVerificationDto
    export type MembershipControllerConfirmTrialVerificationMutationError = ProblemDetail

    export const useMembershipControllerConfirmTrialVerification = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerConfirmTrialVerification>>, TError,{data: ConfirmTrialVerificationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerConfirmTrialVerification>>,
        TError,
        {data: ConfirmTrialVerificationDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerConfirmTrialVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const membershipControllerCreateTrialVerification = (
    createTrialVerificationDto: CreateTrialVerificationDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<TrialVerificationResponse>(
      {url: `/v1/membership/trial/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTrialVerificationDto, signal
    },
      );
    }
  


export const getMembershipControllerCreateTrialVerificationMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateTrialVerification>>, TError,{data: CreateTrialVerificationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateTrialVerification>>, TError,{data: CreateTrialVerificationDto}, TContext> => {

const mutationKey = ['membershipControllerCreateTrialVerification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerCreateTrialVerification>>, {data: CreateTrialVerificationDto}> = (props) => {
          const {data} = props ?? {};

          return  membershipControllerCreateTrialVerification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerCreateTrialVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerCreateTrialVerification>>>
    export type MembershipControllerCreateTrialVerificationMutationBody = CreateTrialVerificationDto
    export type MembershipControllerCreateTrialVerificationMutationError = ProblemDetail

    export const useMembershipControllerCreateTrialVerification = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerCreateTrialVerification>>, TError,{data: CreateTrialVerificationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerCreateTrialVerification>>,
        TError,
        {data: CreateTrialVerificationDto},
        TContext
      > => {

      const mutationOptions = getMembershipControllerCreateTrialVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    